import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { PpWOC } from '@noah-labs/fe-shared-ui-shared';
import { MuiSvgIcon } from '../icons/MuiSvgIcon';
import { TextOrSkeleton } from '../typography/TextOrSkeleton';

export type PpAddressWithIcon = PpWOC & {
  containerStyles?: SerializedStyles;
  noWrap?: boolean;
  svg?: TpReactSvg | null;
};

export function AddressWithIcon({
  children,
  containerStyles,
  noWrap = true,
  svg,
}: PpAddressWithIcon): React.ReactElement {
  const theme = useTheme();
  const styles = {
    addressDisplayContainer: css`
      align-items: center;
      justify-content: center;
      width: 100%;
      color: ${theme.palette.grayscale[600]};
    `,
    icon: css`
      font-size: 1.125rem;
    `,
    textWrap: css`
      overflow: auto;
      word-wrap: break-word;
      word-break: break-word;
    `,
  };

  return (
    <Stack css={[styles.addressDisplayContainer, containerStyles]} direction="row" spacing={1}>
      {svg && <MuiSvgIcon css={styles.icon} svg={svg} />}
      <Typography css={!noWrap && styles.textWrap} noWrap={noWrap} variant="paragraphBodyS">
        <TextOrSkeleton sx={{ px: '6em' }}>{children}</TextOrSkeleton>
      </Typography>
    </Stack>
  );
}
